/**
 * A suspended team (STRIPE P5-F2, PD7; v3 P5-B11 — `refabric/docs/fe_notes.md` "A suspended team keeps its session").
 *
 * `teams.status` ≠ active keeps the session but restricts the team. v3 says so in three places, always by machine code:
 *  - any gated route (capabilities, credit spend, `/v1/teams/*`, and five billing routes BEFORE their action-item
 *    envelope): HTTP 403 `{"error": {"code": "team_suspended", "message": …}}`;
 *  - `POST /users/token_control`: 200 with `team_suspended: true` (present only when true; behind TEAM_SUSPENDED_403);
 *  - `/users/login` (and refresh_token / external_login): the 402 limited answer with `responseData.reason_code: "team_suspended"`.
 * Keyed on the code, never on the message and never on a bare 403 — `permission_denied` and `must_set_password` keep
 * their own handling. Nothing is persisted: with the flag on, token_control re-reports it after a reload, and a shared
 * browser never shows one user's suspension to the next.
 */
export const TEAM_SUSPENDED = "team_suspended";

export const isTeamSuspendedError = (error: any): boolean => error?.response?.status === 403 && error?.response?.data?.error?.code === TEAM_SUSPENDED;

export const isTeamSuspendedLogin = (error: any): boolean => error?.response?.status === 402 && error?.response?.data?.responseData?.reason_code === TEAM_SUSPENDED;

export const isSuspendedSession = (res: any): boolean => !!res && !res._handled && res.responseData?.team_suspended === true;
